/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserValidityComponent } from "./browser-validity/browser-validity.component";
import { FlexLayoutModule } from "@angular/flex-layout";

@NgModule({
  declarations: [BrowserValidityComponent],
  imports: [CommonModule, FlexLayoutModule],
  exports: [BrowserValidityComponent],
})
export class BrowserValidationModule {}
